import React, { useState } from "react";
import axios from "axios";
import "../styles/Section9.css";
import PhoneInput from "react-phone-input-2"; 
import "react-phone-input-2/lib/style.css";   
import Inputtype from "./Inputtype";
import Map from "./Map";

function Section9() {



  const [data, setData] = useState({
    firstName: "",
    email: "",
    country: "United States", // Default US country 
    phoneNumber: "+1", // Default US country code
    comment: "",
    appCode: "KRD", 
  });


  const [inputerr, setInputerr] = useState({});
  const [statusMessage, setStatusMessage] = useState(""); 
  const [errorMessage, setErrorMessage] = useState("");
  const [pop, setPop] = useState(false);

  const handleInput = (event) => {
    const { name, value } = event.target;

    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setInputerr((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : `*${name} is required!`,
    }));
  };

  const handlePhoneChange = (value, country) => {
    let formattedValue = value.startsWith("+") ? value : `+${value}`;
    const numericValue = formattedValue.replace(/\D/g, "");
    const countryCodeLength = country?.dialCode.length || 1;
    const phoneWithoutCountryCode = numericValue.slice(countryCodeLength);

    if (phoneWithoutCountryCode.length > 10) return;

    const finalPhoneNumber = `+${numericValue.slice(0, countryCodeLength)}${phoneWithoutCountryCode}`;

    setData((prevData) => ({
      ...prevData,
      phoneNumber: finalPhoneNumber,
      country: country?.name || "Unknown", // ✅ Store the selected country name
    }));

    setInputerr((prevErrors) => ({
      ...prevErrors,
      phoneNumber: phoneWithoutCountryCode.length === 10 ? "" : "*Phone number must be exactly 10 digits!",
    }));
  };

  const validateForm = () => {
    let err = {};

    if (!data.firstName) err.firstName = "*First name is required!";
    if (!data.email) err.email = "*Email ID is required!";
    if (!data.comment) err.comment = "*Message is required!";
    if (!data.phoneNumber || data.phoneNumber.length < 10)
      err.phoneNumber = "*Phone number must be exactly 10 digits!";

    setInputerr(err);
    return Object.keys(err).length === 0;
  };  
  




  const handleSubmit = async () => {
    if (!validateForm()) {
      setErrorMessage("Please fill all required fields.");
      setTimeout(() => setErrorMessage(""), 5000); // ❌ Hide after 5 seconds
      return;
    }

    try {
      const response = await axios.post("https://apiv1.worknotion.com/allContactUS/saveContactData", data);

      console.log("Contact form submitted:", response.data);
      setStatusMessage(response.data); // ✅ Show success message
      setErrorMessage(""); // ✅ Clear any error message

      setTimeout(() => setStatusMessage(""), 5000); // ✅ Hide after 5 seconds

      setData({
        firstName: "",
        email: "",
        phoneNumber: "+1",
        country: "United States",
        comment: "",
        appCode: "KRD",
      });
    } catch (error) {
      setErrorMessage(error.response?.data || "Something went wrong!");
      setTimeout(() => setErrorMessage(""), 5000); // ❌ Hide after 5 seconds
    }
  };





  return (
    <>
     
     <div className="container-fluid" id="contact-us">
  <div className="row">
    
    {/* Left Column: Map */}
    <div className="col-lg-6 px-0">
      <Map />
    </div>

    {/* Right Column: Form */}
    <div className="col-lg-6 d-flex align-items-center justify-content-center bg-light py-5">
      <div className="w-75 bg-white shadow rounded p-4">
        <h3 className="text-center mb-4 fw-bold">Request a Call Back</h3>

        {/* Name Field */}
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="firstName"
            className={`form-control ${inputerr.firstName ? "is-invalid" : ""}`}
            placeholder="Enter your name"
            value={data.firstName}
            onChange={handleInput}
          />
          {inputerr.firstName && (
            <div className="invalid-feedback">{inputerr.firstName}</div>
          )}
        </div>

        {/* Email Field */}
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className={`form-control ${inputerr.email ? "is-invalid" : ""}`}
            placeholder="Enter your email"
            value={data.email}
            onChange={handleInput}
          />
          {inputerr.email && (
            <div className="invalid-feedback">{inputerr.email}</div>
          )}
        </div>

        {/* Phone Field */}
        <div className="mb-3">
          <label className="form-label">Phone Number</label>
          <PhoneInput
            country={"us"}
            value={data.phoneNumber}
            onChange={handlePhoneChange}
            inputProps={{
              name: "phoneNumber",
              required: true,
              className: `form-control ${inputerr.phoneNumber ? "is-invalid" : ""}`,
            }}
          />
          {inputerr.phoneNumber && (
            <div className="invalid-feedback d-block mt-1">{inputerr.phoneNumber}</div>
          )}
        </div>

        {/* Comment Field */}
        <div className="mb-3">
          <label className="form-label">Message</label>
          <textarea
            name="comment"
            rows="3"
            className={`form-control ${inputerr.comment ? "is-invalid" : ""}`}
            placeholder="Your message"
            value={data.comment}
            onChange={handleInput}
          />
          {inputerr.comment && (
            <div className="invalid-feedback">{inputerr.comment}</div>
          )}
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button
            className="btn btn-primary px-4"
            onClick={handleSubmit}
          >
            Send Request
          </button>
        </div>

        {/* Status Messages */}
        {statusMessage && (
          <div className="alert alert-success mt-3 text-center">{statusMessage}</div>
        )}
        {errorMessage && (
          <div className="alert alert-danger mt-3 text-center">{errorMessage}</div>
        )}
      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default Section9;
